import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { map } from 'rxjs'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { feedbackAPIModel } from 'src/app/models/api.model'
import { save_feedback_action } from 'src/app/store/action/feedback.action'
import { AppState } from 'src/app/store/state/app.state'
import { WebService } from '../api/web.service'

@Injectable({
  providedIn: 'root'
})
export class HelpFeedbackService {
  constructor(private appState: Store<AppState>,private webservice: WebService,) {}

  dispatchSaveFeedbackAction(feedback: feedbackAPIModel) {
    this.appState.dispatch(save_feedback_action({ feedback }))
  }

  callSaveApi = (feedback: feedbackAPIModel) => {
    const endPoint = ServiceUrlConstants.API_SAVE_FEEDBACK
    return this.webservice.post(endPoint, feedback).pipe(map((data: feedbackAPIModel) => data))
  }
}
